var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center pl-1" }, [
    _c(
      "div",
      { staticClass: "text-center mr-1", staticStyle: { width: "40px" } },
      [
        !!_vm.picture.length
          ? _c("img", {
              attrs: { src: _vm.picture, width: "40", height: "40" },
            })
          : _c("i", { staticClass: "fa fa-mobile fa-2x text-muted" }),
      ]
    ),
    _vm._v(" "),
    _c("div", [
      _c("h3", { staticClass: "text-md font-weight-bold mb-1 text-md" }, [
        _vm._v(_vm._s(_vm.item.name)),
      ]),
      _vm._v(" "),
      _vm.item.profile
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center text-gray-500 text-sm" },
            [
              _c("ProfileIcon", {
                staticClass: "text-xs text-gray-400 mr-1",
                attrs: { icon: _vm.item.profile.icon },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.item.profile.name))]),
            ],
            1
          )
        : _c("div", { staticClass: "text-danger text-sm" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("profile.form.no_profile")) + "\n    "
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }